import * as React from "react";

import { twMerge, twJoin } from "tailwind-merge";
import clsx from "clsx";

const DataGrid = React.forwardRef(
  ({ className, data, children, ...props }, ref) => (
    <div
      ref={ref}
      className={twJoin(
        "border-collapse pt-3 relative w-full text-sm text-neutral-600",
        className,
      )}
      {...props}
    >
      {data?.length > 0
        ? data.map((item, index) => {
            if (item.value === null) {
              return null;
            }

            return (
              <DataGridRow key={index}>
                <DataGridLabel>{item.label}</DataGridLabel>
                <DataGridValue>{item.value}</DataGridValue>
              </DataGridRow>
            );
          })
        : children}
    </div>
  ),
);
DataGrid.displayName = "DataGrid";

const DataGridRow = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={twMerge(
      clsx(
        "transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted grid grid-cols-[minmax(200px,20%)_1fr] rounded-md",
        className,
      ),
    )}
    {...props}
  />
));
DataGridRow.displayName = "DataGridRow";

const DataGridLabel = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={twJoin(
      "p-2 first:pl-6 last:pr-6 font-medium align-middle [&:has([role=checkbox])]:pr-0 text-ellipsis overflow-hidden",
      className,
    )}
    {...props}
  />
));
DataGridLabel.displayName = "DataGridLabel";

const DataGridValue = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={twJoin(
      "p-2 first:pl-6 last:pr-6 font-medium align-middle text-black [&:has([role=checkbox])]:pr-0 text-ellipsis overflow-hidden",
      className,
    )}
    {...props}
  />
));
DataGridValue.displayName = "DataGridValue";

export { DataGrid, DataGridRow, DataGridLabel, DataGridValue };
